var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0499 6.95152C11.1827 6.58479 11.2591 6.19114 11.2591 5.77834C11.2591 3.87605 9.71693 2.3335 7.81425 2.3335C5.92942 2.3335 4.40084 3.84765 4.37252 5.72559H4.36958C2.72856 5.72559 1.39844 7.05562 1.39844 8.69621C1.39844 10.3368 2.72846 11.6668 4.36958 11.6668H10.6632C11.9746 11.6668 13.038 10.6035 13.038 9.29202C13.0384 8.11253 12.1769 7.13617 11.0499 6.95134L11.0499 6.95152ZM8.82237 7.85115L7.58218 6.94209V9.92232H6.8546V6.94209L5.6144 7.85115L5.18404 7.26435L7.003 5.93069C7.1311 5.8368 7.30528 5.8368 7.43336 5.93069L9.25232 7.26435L8.82237 7.85115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.0435b90161e3bcf462b51d700e76be64.svg";
export { ForwardRef as ReactComponent };